import { LightboxManager } from "./components/LightboxManager.js";

LightboxManager.use();
